import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AlertService {
  private confirmation$ = new BehaviorSubject<string[] | null>(null);

  listen() {
    return this.confirmation$.asObservable();
  }

  confirm(message: string[]) {
    this.confirmation$.next(message);
  }
}

export const provideAlertService = () => ({
  provide: AlertService,
  useClass: AlertService,
});
